import { useState } from 'react';
import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useDeleteData = (collectionPath) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteData = async (docId) => {
        setIsLoading(true);
        setError(null);
        try {
            const docRef = doc(db, collectionPath, docId);
            await deleteDoc(docRef);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return { deleteData, isLoading, error };
};
export default useDeleteData;